<template>
  <!-- 流程表单首页 -->
  <el-container class="formflow">
    <el-header class="ff-header">
      <div
        v-loading="loading.ffHeaderLoading"
        class="ffh-left"
      >
        <router-link
          v-for="(item,index) in tabData"
          :key="index"
          :to="{path: '/worklist'}"
          tag="div"
          class="work-entry"
        >
          <div class="wea-wrapper">
            <i
              :class="item.icon"
              class="we-avatar"
            />
          </div>
          <div class="we-des">
            <div :class="{'wed-num': true}"><span>{{ item.num }}</span><span
                v-if="item.title === '待办/催办'"
                class="wed-num-red"
              >/{{ item.num1 }}</span></div>
            <div class="wed-name">{{ item.title }}</div>
          </div>
        </router-link>
      </div>
      <div class="ffh-right">
        <div class="ffhr-today">今日，</div>
        <div
          class="ffhr-welcome"
          style="margin-top: 10px"
        >{{ todayInfo }}</div>
      </div>
    </el-header>
    <el-row
      :gutter="20"
      style="margin-top: 30px"
    >
      <div class="service-app">
        <div class="sa-header">
          <div class="sa-title">服务应用</div>
          <div
            v-if="serviceApp.length"
            class="wmh-search"
            style="width: 260px;"
          >
            <sw-input
              :placeholder="'输入应用名称进行筛选'"
              v-model="appSearchValue"
              clearable
            />
          </div>
        </div>
        <div
          v-loading="loading.saLoading"
          class="sa-main"
        >
          <div class="sami-wrapper">
            <div
              v-for="(item,index) in filterServiceApp"
              :key="index"
              class="sam-item"
              @click="writeForm(item)"
            >
              <img
                v-lazy="item.logo"
                class="sami-img"
              >
              <div class="sami-info">
                <div
                  :title="item.ff_name"
                  class="samii-title"
                >{{ item.ff_name }}</div>
                <div
                  :title="item.ff_describe"
                  class="samii-des"
                >{{ item.ff_describe }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </el-container>
</template>
<script>
import service, { designFormUrl } from '@/utils/service.js'
import './css/index.scss'
export default {
  data () {
    return {
      loading: {
        ffHeaderLoading: false,
        saLoading: false
      },
      todayInfo: '',
      tabData: [
        {
          title: '待办/催办',
          num: 0,
          num1: 0,
          icon: 'su-icon-daiban',
          path: 'todo'
        },
        {
          title: '我的传阅',
          num: 0,
          icon: 'su-icon-wodeshenqing',
          path: 'urgent'
        },
        {
          title: '我的申请',
          num: 0,
          icon: 'su-icon-cuiban',
          path: 'applyfor'
        },
        {
          title: '我的办结',
          num: 0,
          icon: 'su-icon-wodebanjie',
          path: 'completed'
        }
      ],
      appSearchValue: '',
      serviceApp: []
    }
  },
  computed: {
    filterServiceApp () {
      const filterArr = this.serviceApp.filter(item => {
        return item.ff_name.indexOf(this.appSearchValue) > -1
      })
      return filterArr
    }
  },
  watch: {},
  created () {
    this.getToday()
  },
  mounted () {
    this.getTab()
    this.getServiceApp()
  },
  methods: {
    getToday () {
      var now = new Date()
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      var date = now.getDate()
      var day = now.getDay()
      var arr = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ]
      var week = arr[day]
      var time =
        year +
        '年' +
        month +
        '月 ' +
        date +
        '日' +
        week +
        '，欢迎您回到supwisdom formflow。'
      this.todayInfo = time
    },
    getServiceApp () {
      this.loading.saLoading = true
      service.get('/workCon/yyxx')
        .then(res => {
          this.serviceApp = res.data
          this.loading.saLoading = false
        }).catch(error => {
          this.$swMessage.error(error)
        })
    },
    getTab () {
      this.loading.ffHeaderLoading = true
      service.get('/v1/application/appData')
        .then(res => {
          this.tabData[0].num = res.data.todo
          this.tabData[0].num1 = res.data.myUrge
          this.tabData[1].num = res.data.myRead
          this.tabData[2].num = res.data.myApply
          this.tabData[3].num = res.data.myComplete
          this.loading.ffHeaderLoading = false
        }).catch(error => {
          this.$swMessage.error(error)
        })
    },

    writeForm (item) {
      window.open(`${designFormUrl}/write?fid=${item.fid}&deployid=${item.deployId}&from=adminplatform&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    }
  }
}
</script>
